import { render, staticRenderFns } from "./UserOrderDetail.vue?vue&type=template&id=4fb368d6&scoped=true"
import script from "./UserOrderDetail.vue?vue&type=script&lang=ts"
export * from "./UserOrderDetail.vue?vue&type=script&lang=ts"
import style0 from "./UserOrderDetail.vue?vue&type=style&index=0&id=4fb368d6&lang=scss"
import style1 from "./UserOrderDetail.vue?vue&type=style&index=1&id=4fb368d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb368d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb368d6')) {
      api.createRecord('4fb368d6', component.options)
    } else {
      api.reload('4fb368d6', component.options)
    }
    module.hot.accept("./UserOrderDetail.vue?vue&type=template&id=4fb368d6&scoped=true", function () {
      api.rerender('4fb368d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/UserOrderDetail.vue"
export default component.exports